import { coreAssets } from "../tenants/coreAssets";

export function HeiselAnalyticsPageFooter() {
  return (
    <a
      className="platform-powered-by"
      href="https://heiselanalytics.one/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Powered by Heisel Analytics"
    >
      <span>Powered by</span>
      <span className="platform-powered-by__logos" aria-hidden="true">
        <img
          className="platform-powered-by__logo platform-powered-by__logo--on-light"
          src={coreAssets.heiselLogoLight}
          alt=""
        />
        <img
          className="platform-powered-by__logo platform-powered-by__logo--on-dark"
          src={coreAssets.heiselLogoDark}
          alt=""
        />
      </span>
    </a>
  );
}
